import type { ChangeEvent, FunctionComponent } from 'react';
import * as styles from './Checkbox.module.css';

interface CheckboxProps {
  id: number;
  label?: string;
  readonly?: boolean;
  checked?: boolean;
  onClick?: (newValue: boolean) => void;
}

const Checkbox: FunctionComponent<CheckboxProps> = ({ id, label, readonly, checked, onClick }) => {
  const handleClickElement = (event: ChangeEvent<HTMLInputElement>) => {
    if (readonly) return;
    const newCheckedStatus = event.target.checked;
    onClick && onClick(newCheckedStatus);
  };

  return (
    <label className={styles.chooseManyCheckbox} htmlFor={`checkbox-${id}`}>
      {label}
      <input
        type="checkbox"
        key={`checkbox-${id}`}
        id={`checkbox-${id}`}
        onChange={handleClickElement}
        checked={checked}
        data-testid={`question-checkbox-${id}`}
      />
      <span className={styles.chooseManyCheckmark} />
    </label>
  );
};

export default Checkbox;
